import store from '@/store';
import gsap from 'gsap';
import { DropShadowFilter } from 'pixi-filters';
import {
  Loader,
  Point,
  SimpleRope,
  Sprite,
  Texture,
} from 'pixi.js';
import ticker from '../ticker';
import vars from '../vars';

class Tail {
  constructor(parent, player) {
    this.parent = parent;
    this.player = player;
    this.points = [];
    this.playerPositions = [];
    this.immediate = false;
    this.shadow = new DropShadowFilter({
      color: 0x000000,
      distance: 0,
      alpha: 0.7,
      blur: 0,
      rotation: 0,
      quality: 0,
    });

    // const desiredHiehgt = 100;
    for (let i = 0; i < 10; i += 1) {
      this.points.push(new Point(vars.layout.PLAYER_START_X, (vars.layout.PLAYER_START_Y - 75) + i * 10));
    }
    this.points = this.points.reverse();

    const tailTexture = Loader.shared.resources[`textures/TAIL_${store.state.skin}`].texture;
    this.sprite = new SimpleRope(tailTexture, this.points, 0);
    this.sprite.tint = 0xffffff;
    this.sprite.filters = [this.shadow];

    this.frameHandler = () => { this.frame(); };

    this.resize();
    this.parent.addChild(this.sprite);

    for (let index = 0; index < this.points.length; index += 1) {
      this.playerPositions.push(vars.layout.PLAYER_START_X);
    }

    this.debugPoints = [];
    this.points.forEach((p) => {
      const s = new Sprite(Texture.WHITE);
      s.tint = 0xff0000;
      s.anchor = new Point(0.5, 0.5);
      s.position = p;
      this.debugPoints.push(s);
      // this.parent.addChild(s);
    });
    this.sprite.zIndex = 2;

    ticker.add(this.frameHandler);
  }

  resize() {
    this.sprite.position.y = -300;
  }

  frame() {
    this.debugPoints.forEach((p, i) => {
      p.position = this.points[i];
    });

    this.playerPositions.unshift(this.player.sprite.position.x);
    if (this.immediate) {
      const ps = [];
      this.playerPositions.forEach((p) => { p = ps.push(this.player.sprite.position.x); }); // eslint-disable-line
      this.playerPositions.length = 0;
      this.playerPositions = ps;
    }
    this.playerPositions.length = 10;
    this.points.forEach((point, i) => {
      if (this.immediate) gsap.killTweensOf(point);
      gsap.to(point, {
        x: this.playerPositions[i],
        ease: 'linear.none',
        delay: this.immediate ? 0 : (i * 0.005),
        duration: this.immediate ? 0 : 0.04,
      });
      if (i === 9) this.immediate = false;
    });
  }

  gameover() {
    ticker.remove(this.frameHandler);
    this.sprite.renderable = false;
  }

  replay() {
    ticker.add(this.frameHandler);
    this.sprite.renderable = true;
  }
}

export default Tail;
